import React from "react";
import "./Footer.css";
import Frame from "../../assets/frame.png";

const Footer = () => {
  return (
    <footer>
      <img src={Frame} alt="house-frame" />
    </footer>
  );
};

export default Footer;
